import { Util } from "./util";

const DEFAULT_IDLE_RESET_MS = 3000;

/**
 * Announces once per empty -> populated transition, and again after
 * `idleResetMs` of inactivity even if the list never emptied. `getMessage` is re-read per
 * announce so a mid-session language switch doesn't go stale.
 */
export class SuggestionsAnnouncer {
    private readonly _getMessage: () => string;
    private readonly _idleResetMs: number;
    private _announced = false;
    private _idleTimer: ReturnType<typeof setTimeout> | null = null;

    constructor(getMessage: () => string, idleResetMs = DEFAULT_IDLE_RESET_MS) {
        this._getMessage = getMessage;
        this._idleResetMs = idleResetMs;
    }

    public update(hasSuggestions: boolean): void {
        if (this._idleTimer !== null) {
            clearTimeout(this._idleTimer);
            this._idleTimer = null;
        }

        if (!hasSuggestions) {
            this._announced = false;
            return;
        }

        if (!this._announced) {
            this._announced = true;
            Util.announce(this._getMessage());
        }

        this._idleTimer = setTimeout(() => {
            this._announced = false;
            this._idleTimer = null;
        }, this._idleResetMs);
    }
}
